import Routes from './Routes';
import { routes } from './config';

export { routes };

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/index.tsx